import React from 'react'

import { Image as ImageBase } from './core'

export const Image = React.forwardRef(
  ({ objectFit = 'cover', objectPosition = '50% 50%', src, ...props }, ref) => (
    <ImageBase
      ref={ref}
      width="100%"
      height="100%"
      src={src}
      loading="lazy"
      objectFit={objectFit}
      objectPosition={objectPosition}
      {...props}
    />
  ),
)
